import { getClinicalDataCounts } from '@services/external/clinical-data.api';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { useAppSelector } from './../../app/redux';

async function handler(providerId: string, clintId: string) {
  const { data } = await getClinicalDataCounts(providerId, clintId);
  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useClinicalDataCount(
  clintId: string,
  options?: UseQueryOptions<TQueryData, unknown, TQueryData, string[]>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(
    ['clinicalData:count', providerId, clintId],
    () => handler(providerId, clintId),
    options,
  );
}

export default useClinicalDataCount;
